<template>
	<LayoutOffcanvasStandard ref="offcanvas" id="company-admin-customer-modal-imported" title="Resultados del proceso" bodyClass="container-md vstack gap-5">
		<template #body>
			<table class="table table-sm">
				<tbody>
					<tr v-if="results?.created ?? 0 > 0">
						<td class="px-1 text-sm fw-bold">Clientes creados</td>
						<td class="px-1 text-sm text-end">{{ results?.created ?? 0 }}</td>
					</tr>
					<tr v-if="results?.updated ?? 0 > 0">
						<td class="px-1 text-sm fw-bold">Clientes actualizados</td>
						<td class="px-1 text-sm text-end">{{ results?.updated ?? 0 }}</td>
					</tr>
					<tr v-if="results?.restored ?? 0 > 0">
						<td class="px-1 text-sm fw-bold">Clientes restaurados</td>
						<td class="px-1 text-sm text-end">{{ results?.restored ?? 0 }}</td>
					</tr>
					<tr v-if="results?.trashed ?? 0 > 0">
						<td class="px-1 text-sm fw-bold">Clientes eliminados por una plataforma externa</td>
						<td class="px-1 text-sm text-end">{{ results?.trashed ?? 0 }}</td>
					</tr>
				</tbody>
			</table>
		</template>
		<template #footer>
			<a href="javascript:void(0);" class="link-dark" data-bs-dismiss="offcanvas">Importar una nueva base</a>
			<router-link :to="{ name: 'company.admin.customer.index' }" class="btn rounded-pill btn-primary">Entendido</router-link>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref } from 'vue';
	import router from '@/router';

	export default {
		setup() {
			const offcanvas = ref(null);
			const results = ref({});

			const show = (resultsData) => {
				results.value = resultsData;
				offcanvas.value.offcanvas.show();
			}

			return { offcanvas, results, show };
		}
	}
</script>